import React, { useCallback, useState } from "react";
import { useForm, useWatch } from "react-hook-form";

import GenericInputField, {
  TYPES,
} from "../../genericInputFields/genericInputField";
import TableWrapper from "../tableWrapper/tableWrapper.component";
import useAppContext from "../../../hooks/useAppContext";
import useToast from "../../../hooks/useToast";

import { Button, Dropdown, MenuList, MenuListItem } from "@mbo/forms";
import { CaretDown } from "@mbo/icons";

import { StyledForm, StyledWrapper } from "./cashoutPanel.style";

const CashoutsLayout = ({ cashout }) => {
  const { axios } = useAppContext();
  const displayToast = useToast();

  const [mode, setMode] = useState("current");
  const [actionText, setActionText] = useState("Actions");
  const [disableActions, setDisableActions] = useState(false);
  const [showActions, setShowActions] = useState(false);

  const {
    control,
    formState: { errors },
    register,
    setError,
  } = useForm({
    defaultValues: {
      reason: "",
    },
    mode: "onChange",
  });

  const fields = useWatch({ control });

  const reasonOptions = [
    {
      label: "Paypal account is locked",
      value: "RECEIVER_ACCOUNT_LOCKED",
    },
    {
      label: "Paypal receiving limit exceeded",
      value: "RECEIVING_LIMIT_EXCEEDED",
    },
    {
      label: "Paypal account in non-receivable country",
      value: "RECEIVER_COUNTRY_NOT_ALLOWED",
    },
  ];

  const transactionLinks = [
    {
      label: "Current Transactions",
      value: "current",
    },
    {
      label: "All Transactions",
      value: "all",
    },
    {
      label: "Declined Transactions",
      value: "declined",
    },
  ];

  const handleClick = (e) => {
    e.preventDefault();
    setMode(e.target.name);
  };

  const handleSubmit = useCallback(
    (e, decision) => {
      e.preventDefault();
      setShowActions(false);
      axios
        .post("/admin/solvers/cashouts/decide", {
          decision: decision,
          id: cashout.id,
          reason: fields?.reason,
        })
        .then((res) => {
          setActionText(res.data.data.action);
          setDisableActions(true);
          displayToast({
            success: true,
            message: "Request processed successfully!",
          });
        })
        .catch((err) => {
          Object.entries(err.response.data.data.errors).forEach(
            ([key, errs]) => {
              setError(key, errs);
            },
          );
          displayToast({
            success: false,
            message:
              err.response.data.data.message || "Something went wrong...",
          });
        });
    },
    [cashout, fields],
  );

  return (
    <StyledWrapper>
      {cashout && (
        <div className="cashout-card">
          <div>
            <div className="cashout-user">
              <a href={cashout.user_path} target="_blank" rel="noreferrer">
                {cashout.user_name}
              </a>{" "}
              ({cashout.user_email}, user id {cashout.user_id})
            </div>
            <div className="cashout-type">{cashout.type}</div>
            <div className="cashout-transactions">
              <div className="cashout-transaction-links">
                {transactionLinks.map((table, index) =>
                  table.value != "declined" || cashout.declined ? (
                    <div key={index}>
                      {table.value == mode ? (
                        <span className={table.value}>{table.label}</span>
                      ) : (
                        <a
                          className={table.value}
                          name={table.value}
                          onClick={handleClick}
                        >
                          {table.label}
                        </a>
                      )}
                    </div>
                  ) : undefined,
                )}
              </div>
              <div className="cashout-transaction-table">
                <TableWrapper
                  id={cashout.id}
                  mode={mode}
                  name="cashoutTransactions"
                />
              </div>
            </div>
            <StyledForm className="cashout-form">
              <div className="cashout-input">
                <GenericInputField
                  control={control}
                  error={errors?.reason}
                  name="reason"
                  options={reasonOptions}
                  placeholder="Reason for declining"
                  readOnly={disableActions}
                  register={register}
                  type={TYPES.SELECT_LABELED}
                />
              </div>

              <div className="cashout-actions">
                <Dropdown
                  alignment="end"
                  disabled={disableActions}
                  isOpen={showActions}
                  setIsOpen={setShowActions}
                  targetElement={
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                      variant="primary"
                    >
                      {actionText} {disableActions ? "\u00A0" : <CaretDown />}
                    </Button>
                  }
                >
                  <MenuList gap={1}>
                    <MenuListItem
                      onClick={(e) => {
                        handleSubmit(e, "approve");
                      }}
                    >
                      Approve Cashout
                    </MenuListItem>
                    <MenuListItem
                      onClick={(e) => {
                        handleSubmit(e, "decline");
                      }}
                    >
                      Decline Cashout
                    </MenuListItem>
                    <MenuListItem
                      onClick={(e) => {
                        handleSubmit(e, "deactivate");
                      }}
                    >
                      Decline & Deactivate User
                    </MenuListItem>
                  </MenuList>
                </Dropdown>
              </div>
            </StyledForm>
          </div>
          <div>
            <div className="cashout-timestamp">{cashout.timestamp}</div>
            <div className="cashout-amount">{cashout.amount}</div>
          </div>
        </div>
      )}
    </StyledWrapper>
  );
};

export default CashoutsLayout;
